﻿import { useState, useEffect, useRef } from 'react';
import { connect } from 'react-redux'

//state
import {
    updateCurrentProgress,
    updateCurrentChapterTitle
} from '../../State/actions'


// components
import Question from './Question'
import Account from '../Form/Account'
import PreSign from './PreSign'

const Chapter = ({
    chapter,
    handleNextChapter,
    state,
    currentChapterIndex,
    handleNext,
    handleReset,
    totalChapters,
    handlePreSignSubmit,
    ...props
}) => {

    const questionsToShow = 1
    const [nextQuestion, setNextQuestion] = useState(questionsToShow);
    const [isLastQuestion, setIsLastQuestion] = useState(false)
    const [answered, setAnswered] = useState(null)

    let currentProgress = state.form[0].Answers.length

    const [showAccount, setShowAccount] = useState(false)
    const [showPreSign, setShowPreSign] = useState(false)


    useEffect(() => {
        props.setCurrentChapterTitle(chapter.title)
    }, [chapter.title])
   
    const onNext = () => {
        setAnswered(currentChapterIndex);

        if (nextQuestion < chapter.questions.length) {
            setNextQuestion(nextQuestion + 1)
        } else {
            handleNext()
        }
    }

    // detect last question to insert Account component
    useEffect(() => {
        if (currentChapterIndex === 2 && chapter.questions[chapter.questions.length - 1]) {
            setIsLastQuestion(true)
        }
    }, [currentChapterIndex, chapter.questions])


    const onEdit = (index, id, currentChapterIndex, isLastQuestion) => {
        setNextQuestion(index + 1)
        props.setCurrentChapterTitle(chapter.title)

        handleReset(id, currentChapterIndex, isLastQuestion)

        if (isLastQuestion) {
            setShowAccount(false)
            setShowPreSign(false)
        }

        if (id === 'account') {
            setShowPreSign(false)
        }
    }

    // animation
    const chapterRefs = useRef([]);

    useEffect(() => {
        if (chapterRefs.current[currentChapterIndex]) {
            chapterRefs.current[currentChapterIndex].scrollIntoView({ behavior: "smooth", block: 'nearest', inline: 'start' });
        }
    }, [currentChapterIndex]);

    return (
    <>
            <section className="pension-wizard-block__section"
                ref={(element) => (chapterRefs.current[currentChapterIndex] = element)}
            >
                <div className={`pension-wizard-block__chapter ${answered === currentChapterIndex ? "answered" : null}`}>
                    <div className="pension-wizard-block__chapter__card">
                        <div className="pension-wizard-block__chapter__card__img">
                            <img
                                key={currentChapterIndex}
                                src={`../../../images/0${currentChapterIndex + 1}.svg`}
                                alt=''
                            />
                        </div>

                        <p className="pension-wizard-block__chapter__card__count">Del {currentChapterIndex + 1} av {totalChapters}</p>
                        <h2 className="pension-wizard-block__chapter__card__headline">{chapter.title}</h2>
                        <p className="pension-wizard-block__chapter__card__info">{chapter.preamble}</p>
                    </div>
                </div>


                {props.questions && props.questions.length > 0 && props.questions.slice(0, nextQuestion).map((q, i) => (
                    <Question
                        question={q}
                        key={q.id}
                        headline={q.questionText}
                        text={q.helpText}
                        id={q.id}
                        state={state}
                        total={props.questions.length}
                        handleNext={onNext}
                        totalIndex={currentProgress}
                        index={i}
                        currentChapterIndex={currentChapterIndex}
                        handleReset={onEdit}
                        isLastQuestion={isLastQuestion}
                        handlePreSignSubmit={handlePreSignSubmit}
                        toggleShowAccount={() => setShowAccount(true)}
                        togglePreSign={() => setShowPreSign(true)}
                     />
                ))}
                 
                {showAccount &&
                    <Account
                        state={state}
                        total={currentProgress + 1}
                        progress={currentProgress + 1}
                        totalIndex={currentProgress}
                        currentChapterIndex={currentChapterIndex}
                        handleNext={onNext}
                        handleReset={onEdit}
                        togglePreSign={() => setShowPreSign(true)}
                    />
                }

                {showPreSign && <PreSign state={state} />}
            </section>
       </>
    )
}

// state
const mapDispatchToProps = (dispatch) => {
    return {
        setCurrentProgress: (payload) => dispatch(updateCurrentProgress(payload)),
        setCurrentChapterTitle: (payload) => dispatch(updateCurrentChapterTitle(payload))
    }
};

export default connect(null, mapDispatchToProps)(Chapter);

